/*
* @Author: gujianghua
* @Date:   2020-05-22 15:44:16
* @Last Modified by:   gujianghua
* @Last Modified time: 2020-07-30 15:22:58
*/
import fileSaver from 'file-saver'
import XLSX from 'xlsx'
export default{
	exportEx(dom, name){
		let date = new Date()
		let time = date.getFullYear()+''+(date.getMonth()+1)+''+date.getDate()
		name = name + time + '.xlsx'
		// let blob = new Blob([dom], {type: "application/octet-stream"});
		// fileSaver.saveAs(blob, name);


		/* generate workbook object from table */
         var wb = XLSX.utils.table_to_book(dom)
         var sheets = wb.Sheets.Sheet1
         for(let i in sheets){	//单元格全部设为文本
         	if(sheets[i].t){
         		sheets[i].t = "s"
         		sheets[i].v = sheets[i].v.toString()
         	}
         }
         /* get binary string as output */
         var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
         try {
             fileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), name)
         } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
         return wbout
	},
	download(api, data, filename) {
		return new Promise((resolve, reject) => {
			api(data).then(res => {
				const _data = res.data
				const url = window.URL.createObjectURL(new Blob([_data]))
				const link = document.createElement('a')
				link.style.display = 'none'
				link.href = url
				var date = new Date().getTime()
				link.setAttribute(
					'download',
					filename + date + '.xlsx'
				)
				document.body.appendChild(link)
				link.click()
				resolve()
			}).catch(e => {
				reject()
			})
		})
		
	}
} 


// WEBPACK FOOTER //
// ./src/utils/exportExcel.js